import { cn } from "../../lib/utils";

// Stipulation status display vocabulary (mapped from the BFF status enum in
// features/stipulations/api/statusMap.ts). Matches the Pre-Approval Beta design.
export type StipulationStatusDisplay = "open" | "closed" | "waived" | "exception" | "reopened";

const BASE_CLASS =
  "inline-flex w-fit items-center rounded-full border bg-transparent px-3 py-0.5 text-xs font-semibold";

// Per-status colors live as tokens in styles/theme.css (no arbitrary hex in
// components). Keyed by the full union so adding a status without a color is a
// compile error — the map can't silently drift from the type.
const STATUS_BADGE_CLASS: Record<StipulationStatusDisplay, string> = {
  open: "border-stip-open text-stip-open",
  closed: "border-stip-closed text-stip-closed",
  waived: "border-stip-waived text-stip-waived",
  exception: "border-stip-exception text-stip-exception",
  reopened: "border-stip-reopened text-stip-reopened",
};

interface StatusBadgeProperties {
  status: StipulationStatusDisplay;
  /** Localized, human-readable status label (the accessible indicator, not color alone). */
  label: string;
  className?: string;
}

// Renders a stipulation status as a colored outlined pill.
export function StatusBadge({ status, label, className }: StatusBadgeProperties) {
  return (
    <span
      data-slot="status-badge"
      data-status={status}
      className={cn(BASE_CLASS, STATUS_BADGE_CLASS[status], className)}
    >
      {label}
    </span>
  );
}
